import {
    GET_MATERIALS,
    SET_MATERIALS_LOADING,
    GET_MATERIALS_FAIL,
    CLEAR_MATERIALS,
    POST_MATERIAL,
    POST_MATERIAL_SET_LOADING,
    POST_MATERIAL_SUCCESS,
    POST_MATERIAL_FAIL,
    GET_PERSONEL,
    SET_PERSONEL_LOADING,
    GET_PERSONEL_FAIL,
    CLEAR_PERSONEL,
    POST_PERSONEL_FAIL,
    POST_PERSONEL_SUCCESS,
    POST_PERSONEL_SET_LOADING,
    POST_PERSONEL,
    CLEAR_NUMER_OPK_PROC,
    GET_NUMER_OPK_PROC_FAIL,
    SET_NUMER_OPK_PROC_LOADING,
    GET_NUMER_OPK_PROC,
    CLEAR_NUMER_OPK_PROC507,
    GET_NUMER_OPK_PROC_FAIL507,
    SET_NUMER_OPK_PROC_LOADING507,
    GET_NUMER_OPK_PROC507,
    CLEAR_CATEGORY_PERSONEL,
    GET_CATEGORY_PERSONEL_FAIL,
    SET_CATEGORY_PERSONEL_LOADING,
    GET_CATEGORY_PERSONEL,
    CLEAR_PROCEDURE,
    GET_PROCEDURE_FAIL,
    SET_PROCEDURE_LOADING,
    GET_PROCEDURE,
    CLEAR_ICD9,
    GET_ICD9_FAIL,
    SET_ICD9_LOADING,
    GET_ICD9,
    POST_PROCEDURA,
    POST_PROCEDURA_SET_LOADING,
    POST_PROCEDURA_SUCCESS,
    POST_PROCEDURA_FAIL,
    CLEAR_ERROR_MATERIALS,
    EDIT_MATERIAL_SET_LOADING,
    EDIT_MATERIAL_FAIL,
    EDIT_MATERIAL_SUCCESS,
    EDIT_PERSONEL_SET_LOADING,
    EDIT_PERSONEL_FAIL,
    EDIT_PERSONEL_SUCCESS, DELETE_MATERIAL_SUCCESS, DELETE__MATERIAL_FAIL, DELETE_PERSONEL_FAIL, DELETE_PERSONEL_SUCCESS,
    GET_MATERIAL_TEMPLATE, POST_MATERIAL_FILE, POST_MATERIAL_FILE_LOADING, POST_MATERIAL_FILE_FAIL,
    DELETE_PROCEDURA_SUCCESS, DELETE_PROCEDURA_FAIL
} from '../actions/types'
import {
    EDIT_PROCEDURE_STAFF_CALUCATION,
    GET_MATERIAL_TYPE,
    GET_MATERIAL_TYPE_ERROR,
    GET_UNIT_TYPE,
    GET_UNIT_TYPE_ERROR, POST_AVAILABLE_PERSONEL, POST_MATERIAL_TYPE, POST_MATERIAL_TYPE_ERROR,
    POST_UNIT_TYPE, POST_UNIT_TYPE_ERROR, TYPE_LOADING
} from "../actions/actions";

const initialState = {
    materials: null,
    loadingMaterials: true,
    errorMaterials: null,
    loadingPostMaterial:true,
    errorPostMaterial:null,

    personel: null,
    loadingPersonel: true,
    errorPersonel: null,
    loadingPostPersonel:true,
    errorPostPersonel:null,

    opk:null,
    loadingOPK:true,
    errorOPK:null,

    opk507:null,
    loadingOPK507:true,
    errorOPK507:null,

    categories:null,
    loadingCategories:true,
    errorCategories:null,

    procedures:null,
    loadingProcedure:true,
    errorProcedure:null,

    icd9:null,
    loadingICD9:true,
    errorICD9:null,

    loadingPostProcedure:true,
    errorPostProcedure:null,

    unitTypes:[],
    materialTypes:[],
    errorType:null,
    typeLoading:false,
    newMaterial:null,
    newUnit:null,
    newPersonelCat:null,

    uploadedFileMaterial: {},
    loadingFileMaterial: false,
    errorFileMaterial: null,
    templateMaterial: null,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_MATERIALS:
            return{
                ...state,
                materials: action.payload,
                loadingMaterials:false
            }
        case SET_MATERIALS_LOADING:
            return{
                ...state,
                loadingMaterials:true
            }
        case GET_MATERIALS_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorMaterials:action.payload
            }
        case CLEAR_MATERIALS:
            return{
                ...state,
                materials:null
            }
        case POST_MATERIAL_SUCCESS:
            return {
                ...state,
                loadingPostMaterial: false,
                errorPostMaterial: null,
                materials: [action.payload, ...state.materials],
                newMaterial:null,
                newUnit:null
            }
        case POST_MATERIAL_FAIL:
            return {
                ...state,
                loadingPostMaterial: false,
                errorPostMaterial: action.payload,
                newMaterial:null

            }
        case POST_MATERIAL_SET_LOADING:
            return{
                ...state,
                loadingPostMaterial: true
            }
//personel
        case GET_PERSONEL:
            return{
                ...state,
                personel: action.payload,
                loadingPersonel:false
            }
        case SET_PERSONEL_LOADING:
            return{
                ...state,
                loadingPersonel:true
            }
        case GET_PERSONEL_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorPersonel:action.payload
            }
        case CLEAR_PERSONEL:
            return{
                ...state,
                personel:null
            }
        case POST_PERSONEL_SUCCESS:
            return {
                ...state,
                loadingPostPersonel: false,
                errorPostPersonel: null,
                personel: [action.payload,...state.personel],
                newPersonelCat:null
            }
        case POST_PERSONEL_FAIL:
            return {
                ...state,
                loadingPostPersonel: false,
                errorPostPersonel: action.payload
            }
        case POST_PERSONEL_SET_LOADING:
            return{
                ...state,
                loadingPostPersonel: true
            }
            //opk proced
        case GET_NUMER_OPK_PROC:
            return{
                ...state,
                opk: action.payload,
                loadingOPK:false,
                errorOPK:null
            }
        case SET_NUMER_OPK_PROC_LOADING:
            return{
                ...state,
                loadingOPK:true
            }
        case GET_NUMER_OPK_PROC_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorOPK:action.payload
            }
        case CLEAR_NUMER_OPK_PROC:
            return{
                ...state,
                opk:null
            }
            //opk dla proc def
        case GET_NUMER_OPK_PROC507:
            return{
                ...state,
                opk507: action.payload,
                loadingOPK507:false,
                errorOPK507:null
            }
        case SET_NUMER_OPK_PROC_LOADING507:
            return{
                ...state,
                loadingOPK507:true
            }
        case GET_NUMER_OPK_PROC_FAIL507:
            console.error(action.payload)
            return{
                ...state,
                errorOPK507:action.payload
            }
        case CLEAR_NUMER_OPK_PROC507:
            return{
                ...state,
                opk507:null
            }
        //category personel
        case GET_CATEGORY_PERSONEL:
            return{
                ...state,
                categories: action.payload,
                loadingCategories:false,
                errorCategories:null
            }
        case SET_CATEGORY_PERSONEL_LOADING:
            return{
                ...state,
                loadingCategories:true
            }
        case GET_CATEGORY_PERSONEL_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorCategories:action.payload
            }
        case CLEAR_CATEGORY_PERSONEL:
            return{
                ...state,
                categories:null
            }
    ///procedure get
    case GET_PROCEDURE:
        return{
            ...state,
            procedures: action.payload,
            loadingProcedure:false,
            errorProcedure:null
        }
    case SET_PROCEDURE_LOADING:
        return{
            ...state,
            loadingProcedure:true
        }
    case GET_PROCEDURE_FAIL:
        console.error(action.payload)
        return{
            ...state,
            errorProcedure:action.payload
        }
    case CLEAR_PROCEDURE:
        return{
            ...state,
            procedures:null
        }
// get icd9
    case GET_ICD9:
        return{
            ...state,
            icd9: action.payload,
            loadingICD9:false,
            errorICD9:null
        }
    case SET_ICD9_LOADING:
        return{
            ...state,
            loadingICD9:true
        }
    case GET_ICD9_FAIL:
        console.error(action.payload)
        return{
            ...state,
            errorICD9:action.payload
        }
    case CLEAR_ICD9:
        return{
            ...state,
            icd9:null
        }
        //delete procedura
        case DELETE_PROCEDURA_SUCCESS:
      return {
        ...state,
        procedures: [
          ...state.procedures.filter((x) => x.id !== action.payload),
        ],
      };
    case DELETE_PROCEDURA_FAIL:
      return{
        ...state,
        error:action.payload,
     }
///post procedura
    case POST_PROCEDURA_SUCCESS:
        return {
            ...state,
            loadingPostProcedure: false,
            errorPostProcedure: null,
            procedures: [action.payload,...state.procedures ]
        }
    case POST_PROCEDURA_FAIL:
        return {
            ...state,
            loadingPostProcedure: false,
            errorPostProcedure: action.payload
        }
    case POST_PROCEDURA_SET_LOADING:
        return{
            ...state,
            loadingPostProcedure: true
        }
    case GET_UNIT_TYPE_ERROR:
        return {
            ...state,
            typeLoading:false,
            errorType: action.payload
        }
    case GET_UNIT_TYPE:
        return{
            ...state,
            typeLoading:false,
            unitTypes: action.payload
        }
    case GET_MATERIAL_TYPE_ERROR:
        return {
            ...state,
            typeLoading:false,
            errorType: action.payload
        }
    case GET_MATERIAL_TYPE:
        return{
            ...state,
            typeLoading:false,
            materialTypes: action.payload
        }
    case POST_UNIT_TYPE_ERROR:
        return {
            typeLoading:false,
            ...state,
            errorType: action.payload,
            typeLoading:false,
            newUnit:null
        }
    case POST_UNIT_TYPE:
        return{
            ...state,
            typeLoading:false,
            unitTypes: [...state.unitTypes,action.payload],
            newUnit: action.payload,
            typeLoading:false
        }
    case POST_MATERIAL_TYPE_ERROR:
        return {
            typeLoading:false,
            ...state,
            errorType: action.payload,
            newMaterial:null
        }
    case POST_MATERIAL_TYPE:
        return{
            ...state,
            materialTypes: [...state.materialTypes,action.payload],
            typeLoading:false,
            newMaterial:action.payload
        }
    case TYPE_LOADING:
        return{
            ...state,
            typeLoading:true,
        }

    case POST_AVAILABLE_PERSONEL:
        return{
            ...state,
            categories:[...state.categories,action.payload],
            typeLoading:false,
            newPersonelCat: action.payload
        }
    case CLEAR_ERROR_MATERIALS:
        return{
            ...state,
            errorPostMaterial: null
        }
    case EDIT_MATERIAL_SET_LOADING:
        return{
             typeLoading:true,
            ...state,
        }
    case EDIT_MATERIAL_FAIL:
        return{
            ...state,
            errorPostMaterial:action.payload,
            typeLoading:false,
        }
     case EDIT_MATERIAL_SUCCESS:
      return {
        ...state,
        materials: [
          ...state.materials.map((x) => {
            if (x.id == action.payload.id) {
              return action.payload;
            } else return x;
          }),
        ],
      };
    case DELETE_MATERIAL_SUCCESS:
      return {
        ...state,
        materials: [
          ...state.materials.filter((x) => x.id !== action.payload),
        ],
      };
    case DELETE__MATERIAL_FAIL:
      return{
        ...state,
        error:action.payload,
     }
    case EDIT_PERSONEL_SET_LOADING:
        return{
             typeLoading:true,
            ...state,
        }
    case EDIT_PERSONEL_FAIL:
        return{
            ...state,
            errorPostMaterial:action.payload,
            typeLoading:false,
        }
     case EDIT_PERSONEL_SUCCESS:
      return {
        ...state,
        personel: [
          ...state.personel.map((x) => {
            if (x.id == action.payload.id) {
              return action.payload;
            } else return x;
          }),
        ],
      };
      case DELETE_PERSONEL_FAIL:
        return{
            ...state,
            error:action.payload,
        };
     case DELETE_PERSONEL_SUCCESS:
      return {
        ...state,
        personel: [
          ...state.personel.filter((x) => x.id !== action.payload),
        ],
      };
      ///pliki materiały
    case GET_MATERIAL_TEMPLATE:
      return {
        ...state,
        templateMaterial: action.payload,
      };
    case POST_MATERIAL_FILE_LOADING:
        return {
            ...state,
            loadingFileMaterial: true,
            errorFileMaterial: null
        }
    case POST_MATERIAL_FILE:
        let newFile = action.payload
        // if(!newFile['date']) newFile['date'] = new Date()
        return {
            ...state,
            // fileList:[newFile, ...state.fileList],
            uploadedFileMaterial: newFile,
            loadingFileMaterial: false
        }
    case POST_MATERIAL_FILE_FAIL:
        return {
            ...state,
            loadingFileMaterial: false,
            errorFileMaterial: true,
        }


    default:
        return state
        }
    }